const benefitNavigationLabels = {
  BACK: 'KEEP MY ACCESS',
  NEXT: 'END MY MEMBERSHIP',
};

export { benefitNavigationLabels };
